import AttactFileIcons from '@/icons/AttactFileIcons'
import CsvIcons from '@/icons/CsvIcons'
import DeleteOutlineIcons from '@/icons/DeleteOutlineIcons'
import DocIcons from '@/icons/DocIcons'
import ImageIcons from '@/icons/ImageIcons'
import PdfIcons from '@/icons/PdfIcons'
import PptxIcons from '@/icons/PptxIcons'
import TextIcons from '@/icons/TextIcons'
import VideoIcons from '@/icons/VideoIcons'
import XlsxIcons from '@/icons/XlsxIcons'
import React from 'react'
import { Typogaphy } from 'vnetwork-ui'
interface GenericFilePreviewProps {
    name: string
    size: number
    preview: string
    handlePreview: () => void
    thumbnail?: string
    fileType:
        | 'Word'
        | 'Excel'
        | 'PowerPoint'
        | 'CSV'
        | 'Video'
        | 'Text'
        | 'Attachment'
        | 'Image'
        | 'PDF'
    onDelete?: () => void
}

export const getFileIcon = (fileType: string) => {
    // attachment_file_type
    // rebuild fileType to attachment_file_type
    // application/pdf -> PDF
    // application/msword -> Word
    // application/vnd.openxmlformats-officedocument.wordprocessingml.document -> Word
    // application/vnd.ms-excel -> Excel
    // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet -> Excel
    // application/vnd.ms-powerpoint -> PowerPoint
    // application/vnd.openxmlformats-officedocument.presentationml.presentation -> PowerPoint
    // application/vnd.ms-powerpoint -> PowerPoint
    // application/vnd.openxmlformats-officedocument.presentationml.presentation -> PowerPoint
    // application/vnd.ms-powerpoint -> PowerPoint

    switch (fileType?.toLowerCase()) {
        case 'image':
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/webp':
        case 'image/svg+xml':
        case 'image/tiff':
        case 'image/bmp':
        case 'image/x-icon':
        case 'image/x-windows-bmp':
        case 'image/x-ms-bmp':
        case 'image/x-ms-png':
        case 'image/x-ms-gif':
        case 'image/x-ms-webp':
        case 'image/x-ms-svg+xml':
        case 'image/x-ms-tiff':
            return <ImageIcons className="w-5 h-5 text-primary" />
        case 'application/msword':
        case 'word':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'docx':
        case 'doc':
            return <DocIcons className="w-5 h-5 text-blue-600" />
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        case 'excel':
            return <XlsxIcons className="w-5 h-5 text-green-600" />
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'powerpoint':
            return <PptxIcons className="w-5 h-5 text-orange-600" />
        case 'csv':
            return <CsvIcons className="w-5 h-5 text-green-500" />
        case 'video':
            return <VideoIcons className="w-5 h-5 text-purple-600" />
        case 'text':
            return <TextIcons className="w-5 h-5 text-gray-600" />
        case 'application/pdf':
        case 'pdf':
            return <PdfIcons className="w-5 h-5 text-gray-600" />
        default:
            return <AttactFileIcons className="w-5 h-5 text-gray-500" />
    }
}

const GenericFilePreview: React.FC<GenericFilePreviewProps> = ({
    name,
    handlePreview,
    fileType,
    thumbnail,
    onDelete,
}) => {
    const icon = getFileIcon(fileType)

    return (
        <div
            onClick={handlePreview}
            className="cursor-pointer overflow-hidden transition-all duration-200 relative"
        >
            {/* File Header */}
            <div className="bg-transparent flex items-center justify-between gap-1">
                <div className="flex items-center gap-1">
                    {icon}
                    <Typogaphy className="font-medium text-sm truncate">
                        {name}
                    </Typogaphy>
                </div>
                {!!onDelete && (
                    <DeleteOutlineIcons
                        className="w-4 h-4 text-error cursor-pointer"
                        onClick={(event) => {
                            event.stopPropagation()
                            onDelete?.()
                        }}
                    />
                )}
            </div>

            {/* File Content */}
            <div className="h-[120px] mt-2 flex items-center justify-center">
                {thumbnail ? (
                    <>
                        <img
                            src={thumbnail}
                            alt={name}
                            className="w-full h-full rounded-sm object-cover"
                            onError={(e) => {
                                // Fallback if image fails to load
                                const target = e.target as HTMLImageElement
                                target.style.display = 'none'
                                const fallback = document.createElement('div')
                                fallback.className =
                                    'w-full h-32 bg-gray-200 flex items-center justify-center'
                                fallback.innerHTML =
                                    '<span class="text-gray-500 text-sm">Preview not available</span>'
                                target.parentNode?.appendChild(fallback)
                            }}
                        />
                    </>
                ) : (
                    icon
                )}
            </div>
        </div>
    )
}

export default GenericFilePreview
